import { render, staticRenderFns } from "./Recordings.vue?vue&type=template&id=39c3515c&scoped=true&"
import script from "./Recordings.vue?vue&type=script&lang=js&"
export * from "./Recordings.vue?vue&type=script&lang=js&"
import style0 from "./Recordings.vue?vue&type=style&index=0&id=39c3515c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c3515c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lee/Developer/Auris/admin-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39c3515c')) {
      api.createRecord('39c3515c', component.options)
    } else {
      api.reload('39c3515c', component.options)
    }
    module.hot.accept("./Recordings.vue?vue&type=template&id=39c3515c&scoped=true&", function () {
      api.rerender('39c3515c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Recordings.vue"
export default component.exports